import { Outlet } from 'react-router-dom'

const AiReportsRootPage = () => {
  return <Outlet />
}

export default AiReportsRootPage
